import { NewProduct } from '../../types/Products/newProduct';
import { request } from '../../utils/request';

export const updateProduct = (
  id: number,
  updates: Partial<NewProduct>,
  authToken: string,
  store_id: number
) =>
  request({
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    url: `/products/${id}?store_id=${store_id}`,
    callback: undefined,
    formData: updates,
    onError: (err) => {
      throw err;
    },
  });
